import { SVGProps, Ref, forwardRef } from 'react';

export const RocketOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.891 11.18a2.163 2.163 0 0 1 1.942 2.152c0 2.424-2.652 2.163-4.326 2.163 0-1.673-.26-4.325 2.164-4.325zm-.22 1.39c-.334 0-.427.083-.443.097-.037.032-.122.131-.197.406-.083.303-.114.643-.125 1.023.38-.011.72-.042 1.024-.124.274-.075.373-.16.406-.197.013-.015.097-.107.097-.443a.763.763 0 0 0-.762-.762"
                    fill="currentColor"
                />
                <path
                    d="M10.167 4.741c.373.033.642.178.82.393.203.242.28.56.28.866l-.004.115c-.017.27-.098.539-.275.751-.18.215-.448.36-.821.394L10 7.266c-.461 0-.784-.154-.989-.4a1.3 1.3 0 0 1-.274-.75L8.734 6c0-.306.077-.623.278-.865.205-.246.527-.4.988-.4z"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.556 4.507C7.904 2.885 11.23-.083 15.4.6c.685 4.17-2.284 7.496-3.906 8.843.273 2.244-.557 4.46-3.226 6.057-.095-1.327-.374-2.502-.837-3.51l-.646.332-3.107-3.106.333-.648c-.996-.457-2.166-.74-3.51-.836C1.997 5.23 4.039 4.344 6.136 4.47zm7.54-2.604c-2.917.04-5.326 2.13-6.464 3.498l-.487.588-.758-.093c-.893-.108-1.73.007-2.485.377a4.3 4.3 0 0 0-.77.49q.769.215 1.462.533l1.332.611-.537 1.04 1.662 1.662 1.04-.536.612 1.332q.319.697.532 1.462.303-.384.491-.77c.37-.755.486-1.591.377-2.485l-.093-.758.588-.488c1.37-1.138 3.46-3.546 3.497-6.463"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
RocketOutlinedSize16Glyph.displayName = 'RocketOutlinedSize16Glyph';
